import { useTranslation } from 'react-i18next';

import { useDetectUserwayBiggerText } from '../../shared/hooks/useDetectUserwayBiggerText';
import { AccountDetailsLeftMenu } from './accountDetails/AccountDetailsLeftMenu';
import { NotificationsLeftMenu } from './children/NotificationsLeftMenu';

type ProfileSettingsLeftPanelProps = {
  activeMenu: { id: number };
  activeSubMenu: { id: number };
  profile: any;
  isHidden: boolean;
  changeMenu: (arg0: number, arg1: string) => void;
  changeSubMenu: (arg0: number) => void;
  saveProfileImage: (url: string) => void;
};

export function ProfileSettingsLeftPanel({
  activeMenu,
  activeSubMenu,
  profile,
  isHidden,
  changeMenu,
  changeSubMenu,
  saveProfileImage,
}: ProfileSettingsLeftPanelProps) {
  const { isBiggerText } = useDetectUserwayBiggerText();
  const { t } = useTranslation();

  return (
    <div
      role="group"
      aria-label={t('profile.settings.title')}
      className={`menu-left ${isHidden ? 'simplify' : ''} ${isBiggerText ? 'small-padding' : ''}`}
    >
      {activeMenu?.id === 41 && (
        <AccountDetailsLeftMenu
          isHidden={isHidden}
          profile={profile}
          changeMenu={changeMenu}
          activeSubMenu={activeSubMenu}
          changeSubMenu={changeSubMenu}
          saveProfileImage={saveProfileImage}
        />
      )}
      {activeMenu?.id === 43 && (
        <NotificationsLeftMenu
          hide={isHidden}
          profile={profile}
          activeSubMenu={activeSubMenu}
          changeSubMenu={changeSubMenu}
        />
      )}
    </div>
  );
}
